<router-outlet></router-outlet>
<mtg-notifications-container
  *ngIf="user && notificationsEnabled"
  [service]="'public'"
  [notificationSettingsRoute]="notificationSettingsRoute"
></mtg-notifications-container>
